import { createSlice } from "@reduxjs/toolkit";
import {
  AddSequrityQuestionAction,
  DeleteSequrityQuestionAction,
  GetAllSequrityQuestionAction,
  UpdateSequrityQuestionAction,
} from "store/middlewares/securityQuestions";

const initalVal = {
  sequrityQuestion: null,
  sequrityQuestionLoading: true,
};

export const sequrityQuestionSlice = createSlice({
  name: "sequrityQuestion",
  initialState: initalVal,
  extraReducers(builder) {
    builder
      // For Fetch All sequrityQuestion
      .addCase(GetAllSequrityQuestionAction.pending, (state) => {
        // state.sequrityQuestionLoading = true;
        // state.sequrityQuestion = null;
        state.sequrityQuestion =
          state.sequrityQuestion?.data?.length > 0
            ? state.sequrityQuestion
            : null;
      })
      .addCase(GetAllSequrityQuestionAction.fulfilled, (state, action) => {
        state.sequrityQuestionLoading = false;
        state.sequrityQuestion = action.payload.response;
      })
      .addCase(GetAllSequrityQuestionAction.rejected, (state) => {
        state.sequrityQuestionLoading = false;
        state.sequrityQuestion = null;
      })

      // For Add sequrity Question
      .addCase(AddSequrityQuestionAction.fulfilled, (state, action) => {
        // state.sequrityQuestionLoading = false;
        // state.sequrityQuestion = {
        //   ...state.sequrityQuestion,
        //   total: Number(state.sequrityQuestion.total) + 1,
        //   data: [action.payload.response, ...state.sequrityQuestion.data],
        // };
        state.sequrityQuestionLoading = false;
        state.sequrityQuestion = action.payload.response;
      })

      // For Update sequrity Question
      .addCase(UpdateSequrityQuestionAction.fulfilled, (state, action) => {
        state.sequrityQuestionLoading = false;
        state.sequrityQuestion = {
          ...state.sequrityQuestion,
          data: state.sequrityQuestion.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item
          ),
        };
      })

      // For Delete sequrity Question
      .addCase(DeleteSequrityQuestionAction.fulfilled, (state, action) => {
        // state.sequrityQuestionLoading = false;
        // state.sequrityQuestion = {
        //   ...state.sequrityQuestion,
        //   total: Number(state.sequrityQuestion.total) - 1,
        //   data: state.sequrityQuestion?.data?.filter(
        //     (item) => item.id !== action.payload.id
        //   ),
        // };
        state.sequrityQuestionLoading = false;
        state.sequrityQuestion = action.payload.response;
      });
  },
});

export const {
  resetReducer,
  setEmailSentStatus,
  setEmailFilterProps,
  setFaqFilterProps,
  addNewChat,
} = sequrityQuestionSlice.actions;

export default sequrityQuestionSlice.reducer;
